<form *ngIf="caseStateFormGroup" [formGroup]="caseStateFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-3 input-field">
                <label for="code">Código *</label>
                <input pInputText formControlName="code" d-form-field-error />
            </div>
            <div class="col-6 input-field">
                <label for="name">Nombre * </label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-3 input-field">
                <label for="iconClass">Icono</label>
                <input pInputText formControlName="iconClass" d-form-field-error />
                <span>Escriba el código de pi icons</span>
            </div>
            <div class="col-2 input-field">
                <label for="revisionRequired">Requiere revisión *</label>
                <p-checkbox formControlName="revisionRequired" d-form-field-error [binary]="true"></p-checkbox >     
            </div>
            <div class="col-4 input-field">
                <label for="isGeneric">Todas las compañias *</label>
                <p-checkbox formControlName="isGeneric" d-form-field-error [binary]="true"></p-checkbox >     
            </div>
            <div class="col-12 input-field" *ngIf="allowFieldsConfiguration">
                <label for="fieldsConfiguration">Campos a rellenar (JSON)</label>
                <textarea pInputTextarea formControlName="fieldsConfiguration" rows="12" style="font-family: monospace;"></textarea>
                <span>Formulario que se muestra al crear un evento de esta categoría: objeto JSON con una lista "fields". Un contrato puede definir el suyo propio y entonces manda el del contrato.</span>
            </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger"
                (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>